import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import IconAlert from 'components/common/IconAlert';
import { useFormContext } from 'react-hook-form';
import { changeToCoin, changeToNumber } from 'helpers/utils';

const RecipeHeader = () => {
 const {
  watch,
  register,
  setValue,
  formState: { errors }
 } = useFormContext();

 const image = watch('image') ?? [];
 const price = watch('price') ?? '';

 const [amount, setAmount] = useState('');
 //  const [files, setFiles] = useState([]);

 useEffect(() => {
  setAmount(changeToCoin({ amount: price, symbol: true, cents: true }));
 }, [price]);

 const onChange = ({ target: { value } }) => setValue('price', changeToNumber({ amount: value, cents: true }));

 return (
  <Card className="my-3">
   <Background
    image={corner4}
    className="bg-card"
    style={{
     borderTopRightRadius: '0.375rem',
     borderBottomRightRadius: '0.375rem'
    }}
   />
   <Card.Body className="position-relative fs--1">
    {errors.logo && <IconAlert variant="warning">{errors.logo.message}!</IconAlert>}
    <Flex wrap="wrap" alignContent="center" alignItems="center" justifyContent="center" className="mb-0">
     <Avatar
      uploader
      size="5xl"
      src={image[0]?.preview ?? image[0] ?? ''}
      mediaClass="img-thumbnail shadow-sm"
      propUploader={{
       noFiles: true,
       iconClass: 'me-4',
       classInput: 'logo',
       multiple: false,
       onChange: img => {
        setValue('image', img, { shouldValidate: true, shouldTouch: true });
       }
      }}
     />
     <div className="flex-grow-1 border-md-start border-start-2 ms-md-3 ps-md-1">
      <Input
       type="text"
       errors={errors}
       name="name"
       placeholder="Nombre del producto"
       formGroupProps={{ className: 'px-0 pb-1 pt-3 p-md-2' }}
       formControlProps={{ ...register('name'), autoComplete: 'off' }}
      />

      <Flex justifyContent="start" alignItems="center" wrap="wrap">
       <div className="flex-fill fs--2 p-0 pe-2 p-md-2">
        <h5 className="mb-0 text-primary">Precio</h5>
        <p className="mb-0 d-none d-md-block">Establezca su precio</p>
       </div>

       <Input
        type="text"
        errors={errors}
        name="price"
        placeholder="Precio"
        formGroupProps={{ className: 'flex-fill p-0 p-md-2' }}
        formControlProps={{ value: amount, onChange, onFocus: e => e.target.select(), className: 'text-center' }}
       />
      </Flex>
     </div>
    </Flex>
   </Card.Body>
  </Card>
 );
};

export default RecipeHeader;
